
  <div>

    <div class="modal-header customBlueHeader">
      <p class="modal-title">Reports</p>
      <button type="button" aria-label="Close" class="close" (click)="closePopup()">
        <!-- <span aria-hidden="true">×</span> -->
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <!-- <div *ngIf="isReportUploaded" class="succMsg">Report Uploaded Successfully</div> -->
    <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
    <div>
       
        <button type="button" class="upload_btn green_btn upload-finish-btn" *ngIf="isUploadReportButtonReady" (click)="reportIsReady(order_id)">
          Report is Ready
        </button>
      </div>
    <div class="modal-body">
      <form [formGroup]="uploadForm" (ngSubmit)="onSubmit(order_id)">
        <div class="flexBetween"> 
          <input type="file" name="profile" (change)="onFileSelect($event)" *ngIf="isUploadReportButton"/>
          <button type="submit" class="upload_btn green_btn" *ngIf="isUploadReportButton">Upload</button>
        </div>
      </form>

      <!-- <div> <button type="submit" class="upload_btn green_btn" *ngIf="isUploadReportButton" (click)="changeOrderStatus(order_id)">Report Uploaded Finished</button></div> -->
      <div>
       
        <button type="button" class="upload_btn green_btn upload-finish-btn" *ngIf="isUploadReportButton" (click)="changeOrderStatus(order_id)">
         Report Uploaded Finished
        </button>
      </div>
      <div class="mrg-tp-15">
        <table class="table table-striped table-responsive table-hover uploadedRecordTable">
          <thead>
            <tr>
              <th class="width100p">Uploaded Records</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let document of documents">
              <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'">{{document.documentName}}</td>
              <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'"><div class="downLoadLink" (click)="download(document.documentId)" [disabled]="fileDownloadDisable">Download</div></td>
              <!-- <td *ngIf="document.documentType=='labreport' || document.documentType=='imagingreport'" (click)="delete(document.documentId,document.documentName)"><a>Delete</a></td>  -->
              <td *ngIf="(document.documentType=='imagingreport' || document.documentType=='labreport') && isDelete"><div class="downLoadLink" (click)="delete(document.documentId,document.documentName)" >Delete</div></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>


